import css from 'styled-jsx/css';
import { makeStyles } from '@mui/styles';

export const childrenContainerStyles = css`
  .children-container {
    width: 100%;
  }
`;

export const useAccordionStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    backgroundColor: 'white',
    minWidth: '298px',
    borderRadius: '8px',
    boxShadow: 'none',
    flexGrow: 1,

    '&.Mui-expanded': {
      margin: 0,
    },

    '&.MuiAccordion-root:before': {
      backgroundColor: 'transparent',
    },
  },
}));

export const useAccordionSummaryStyles = makeStyles(() => ({
  root: {
    padding: '12px',
    '& .MuiAccordionSummary-content': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      margin: '0',
      fontSize: '14px',
      fontWeight: '700',
      lineHeight: '20px',
      textTransform: 'uppercase',
      letterSpacing: '0.2px',
      paddingLeft: '4px',
    },
    '&.Mui-expanded': {
      minHeight: '0',
      transition: 'height 0.3s ease-in-out',
    },
    '&.MuiButtonBase-root': {
      cursor: 'pointer',
    },
    '@media (hover: hover) and (pointer: fine)': {
      '&:hover': {
        '&:not(.Mui-disabled)': {
          cursor: 'pointer',
        },
        '& .MuiIconButton-label': {
          backgroundColor: '#EBEBEB',
          borderRadius: '4px',
        },
      },
    },
  },
}));

export const useAccordionDetailStyles = makeStyles(() => ({
  root: {
    margin: '0',
    padding: '0',
  },
}));
